import { useMediaQuery, useTheme } from "@mui/material";

export const useIsMobilePhone = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down("sm"));
};
